import {EpLayer} from "./layer";
import {boundariesStyle} from "../styles/boundaries";

export class EpBoundariesLayer extends EpLayer {
    constructor(map) {
        super(map);

        this.style = boundariesStyle;
        this.title = 'Granice obwodu';
        this.name = 'boundaries'

        return this;
    }
}
